<h1 class="cell shrink _primary"[i18nKey]="'area.competition.title'"></h1>

<div class="cell shrink grid-x">
    <kiwi-animator-select-team class="cell shrink"></kiwi-animator-select-team>

    <kiwi-all-periods-selector class="cell shrink"></kiwi-all-periods-selector>
</div>

